import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconHeart({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<filter
					id="a"
					width="120.1%"
					height="139.5%"
					x="-10%"
					y="-10.2%"
					filterUnits="objectBoundingBox"
				>
					<feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
					<feGaussianBlur
						in="shadowOffsetOuter1"
						result="shadowBlurOuter1"
						stdDeviation={0.5}
					/>
					<feColorMatrix
						in="shadowBlurOuter1"
						result="shadowMatrixOuter1"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
					/>
					<feMerge>
						<feMergeNode in="shadowMatrixOuter1" />
						<feMergeNode in="SourceGraphic" />
					</feMerge>
				</filter>
			</defs>
			<g
				fill="none"
				fillRule="evenodd"
				filter="url(#a)"
				transform="translate(2.096 7.635)"
			>
				<path
					fill="#CD0400"
					d="M12.392.588c-1.048 0-1.712.648-2.084 1.192a4 4 0 0 0-.248.416 4 4 0 0 0-.247-.416C9.44 1.236 8.777.588 7.729.588c-.746 0-1.427.317-1.918.894-.468.55-.725 1.286-.725 2.074 0 .857.323 1.655 1.017 2.51.62.763 1.512 1.55 2.545 2.462.386.34.784.691 1.208 1.075l.012.012a.285.285 0 0 0 .384 0l.013-.012c.424-.384.822-.735 1.207-1.075 1.033-.911 1.926-1.699 2.546-2.463.694-.854 1.017-1.652 1.017-2.51 0-.787-.258-1.523-.726-2.073a2.49 2.49 0 0 0-1.917-.894"
				/>
				<path
					fill="#CD0400"
					d="M7.547 6.83c-.89-.39-2.16-.483-2.277-.49-1.263-.162-1.797-.568-2.023-.88-.231-.32-.19-.602-.188-.614l.03-.19-.184-.037C1.592 4.38 1.531 2.907 1.53 2.844l-.005-.15-.14-.034C.557 2.458.302 1.61.223 1.088c.797.447 2.438.691 3.463.746 1.296.068 1.82.63 1.898.723l1.962 4.274Z"
				/>
				<path
					fill="#FFF"
					d="M0 .665s-.03 1.85 1.34 2.185c0 0 .046 1.69 1.533 1.962 0 0-.254 1.388 2.38 1.723 0 0 1.987.127 2.726.781L5.745 2.451s-.539-.733-2.048-.813C2.187 1.558.354 1.159 0 .665m.49.76c.987.399 2.514.569 3.188.604 1.149.06 1.642.523 1.748.64l1.753 3.817c-.814-.258-1.713-.33-1.891-.341-1.18-.152-1.674-.514-1.88-.79-.175-.234-.166-.438-.163-.474l.091-.382-.398-.073c-.478-.087-.826-.368-1.035-.836a2.3 2.3 0 0 1-.185-.75l-.008-.302-.283-.069C1 2.364.694 2.047.521 1.526z"
				/>
				<path
					fill="#FFF"
					d="m3.822 4.406.051.199-.682.188-.051-.199zm.556-2.293.051.199-.682.189-.051-.199zm-2.143.593.052.199-.682.189-.052-.199zm1.071-.296.052.199-.682.188-.051-.199zm5.319 7.3.005-.009.002.007zm6.299-3.881-.051-.2.681-.188.052.199zm.506-2.492.608-.169.118.181-.676.187-.05-.2Zm-1.566 2.785-.052-.199.023-.007.648-.179.051.199-.448.124zm-7.9-2.309.052.199-.682.189-.051-.199zm.515 1.996.052.199-.682.189-.051-.199zm-1.586-1.7.051.199-.682.189-.051-.199zm9.516-.277-.051-.199.681-.188.052.199zm1.586 1.7-.051-.199.682-.189.051.199zm-3.203.886-.051-.199.682-.188.051.199z"
				/>
				<path
					fill="#CD0400"
					d="M14.318 2.558c.078-.09.614-.657 1.898-.724 1.025-.055 2.666-.299 3.463-.746a3 3 0 0 1-.115.491c-.196.595-.547.959-1.045 1.08l-.141.035-.004.15c-.002.063-.063 1.536-1.377 1.775l-.188.035.035.195c.002.01.044.29-.188.61-.226.313-.76.72-2.023.88-.117.009-1.387.102-2.277.492z"
				/>
				<path
					fill="#FFF"
					d="M19.903.665c-.354.494-2.187.893-3.697.973s-2.049.813-2.049.813l-2.233 4.865c.74-.654 2.726-.781 2.726-.781 2.634-.335 2.38-1.723 2.38-1.723 1.487-.271 1.533-1.962 1.533-1.962 1.37-.335 1.34-2.185 1.34-2.185m-.49.76q-.014.05-.03.1c-.175.522-.48.84-.907.944l-.28.07-.011.299c0 .003-.015.37-.186.752-.208.468-.556.75-1.034.836l-.403.053.095.402c.004.035.013.24-.161.473-.207.277-.7.639-1.88.79-.179.012-1.078.084-1.892.342l1.753-3.818c.106-.116.599-.578 1.748-.639.673-.035 2.201-.205 3.188-.604"
				/>
				<path
					fill="#FFF"
					d="m16.081 4.406-.051.199.682.188.051-.199zm-.556-2.293-.051.199.681.189.052-.199zm2.143.593-.052.199.682.189.052-.199zm-1.072-.296-.051.199.682.188.051-.199zm-5.318 7.3-.005-.009-.002.007zm2.661-5.897-.052.199.682.189.051-.199zm-.515 1.996-.052.199.682.189.052-.199zm1.586-1.7-.051.199.682.189.051-.199z"
				/>
				<path
					fill="#FFF"
					d="M10.06 8.906a.1.1 0 0 1-.067-.026l-.013-.01c-.427-.387-.824-.738-1.209-1.077-1.027-.906-1.913-1.689-2.523-2.44-.664-.818-.973-1.575-.973-2.384 0-.74.24-1.43.678-1.944A2.3 2.3 0 0 1 7.728.196c.968 0 1.584.603 1.93 1.11q.127.184.235.395l.167.321.167-.321q.108-.21.235-.396c.347-.506.963-1.11 1.93-1.11.69 0 1.321.295 1.776.829.437.514.678 1.205.678 1.944 0 .81-.31 1.566-.973 2.384-.61.751-1.497 1.534-2.523 2.44l-.012.01c-.382.337-.777.685-1.197 1.067l-.013.011a.1.1 0 0 1-.068.026"
				/>
				<path
					fill="#CD0400"
					d="M12.392 0c-1.048 0-1.712.648-2.084 1.192a4 4 0 0 0-.248.416 4 4 0 0 0-.247-.416C9.44.648 8.777 0 7.729 0 6.983 0 6.302.318 5.81.894c-.468.55-.725 1.287-.725 2.075 0 .857.323 1.654 1.017 2.509.62.764 1.512 1.551 2.545 2.463.386.34.784.691 1.208 1.075l.012.012a.284.284 0 0 0 .384 0l.013-.012c.424-.384.822-.735 1.207-1.075 1.033-.912 1.926-1.7 2.546-2.463.694-.855 1.017-1.652 1.017-2.51 0-.787-.258-1.524-.726-2.074A2.49 2.49 0 0 0 12.392 0m0 .392c.636 0 1.215.27 1.633.761.408.479.632 1.123.632 1.816 0 .76-.295 1.477-.929 2.257-.6.739-1.48 1.516-2.503 2.418-.372.329-.756.667-1.165 1.037-.41-.37-.794-.71-1.166-1.038-1.02-.9-1.902-1.678-2.502-2.417-.633-.78-.928-1.498-.928-2.257 0-.693.224-1.337.631-1.816A2.12 2.12 0 0 1 7.73.392c.886 0 1.454.558 1.775 1.027q.12.175.223.374l.333.644.334-.644a4 4 0 0 1 .223-.374c.32-.469.889-1.027 1.775-1.027"
				/>
			</g>
		</svg>
	);
}
